import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FormGroup,
  Icon,
  InputGroup,
  Spinner,
  Switch,
  Tab,
  Tabs,
  TextArea,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api_adm } from "../../api";
import { IProduto } from "../../model";
import { ProdutoStore } from "../../stores/legislacao/ProdutoStore";
import { toast } from "react-toastify";
import { MDBCol, MDBRow } from "mdbreact";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from "moment";

interface ProdutoDialogProps {
  produto: IProduto;
  onClose: () => void;
  estado: string;
}

interface ProdutoDialogState {
}

@observer
export class ProdutoDialog
  extends React.Component<ProdutoDialogProps, ProdutoDialogState> {
  obs = observable({
    produto: {} as IProduto,
    open_select_segments: false as boolean
  })

  async componentDidMount() {
    this.obs.produto = observable(this.props.produto);
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  /**
  * Salva ou atualiza um produto na API de administração.
  *
  * A função:
  * - Atualiza o campo `estado` do produto com o valor vindo de `props`.
  * - Se o produto já tiver `id`, realiza um **PUT** em `/api/admin/produtos/:id`.
  * - Caso contrário, realiza um **POST** em `/api/admin/produtos`.
  * - Após persistir:
  *   - Determina se o produto é de `entrada` ou `saida`.
  *   - Chama `ProdutoStore.loadProdutos` para recarregar a listagem.
  *   - Exibe uma notificação de sucesso.
  *   - Fecha o modal/janela atual via `this.props.onClose()`.
  * - Em caso de erro, exibe uma notificação de falha.
  * 
  * @async
  * @returns {Promise<void>} Promise resolvida após salvar ou atualizar o produto.
  *
  * @throws {Error} Lança exceções caso a chamada à API falhe (capturadas pelo `catch`).
  */
  handleSave = async () => {
    try {
      this.obs.produto.estado = this.props.estado

      let resp = null
      
      if (this.obs.produto.id) {
        resp = await api_adm.put(`/api/admin/produtos/${this.obs.produto.id}`, this.obs.produto);
      } else {
        resp = await api_adm.post("/api/admin/produtos", this.obs.produto);
      }
      //ProdutoStore.obs.produtos.push(this.obs.produto.model);
      let entrada_saida: string = this.obs.produto.entrada ? "entrada" : "saida";
      ProdutoStore.loadProdutos(1, "", entrada_saida, this.props.estado)
      toast.success('Produto atualizado', {});
      this.props.onClose();
    } catch (ex) {
    
      toast.error(`Erro ao atualizar Produto!`, {});
    
    }

  };

  renderData() {
    let dayPickerProps = {
              localeUtils: MomentLocaleUtils,
              locale: "pt-br",
            };
    return (
      <div>
        <FormGroup
          label="Descrição"
          labelFor="descricao"
        >
          <TextArea
            id="descricao"
            style={{ width: "100%" }}
            value={this.obs.produto.descricao}
            onChange={(e: any) => this.obs.produto.descricao = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="NCM"
          labelFor="ncm"
        >
          <InputGroup
            id="ncm"
            style={{ width: "50%" }}
            value={this.obs.produto.ncm}
            onChange={(e: any) => this.obs.produto.ncm = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="CEST"
          labelFor="cest"
        >
          <InputGroup
            id="cest"
            style={{ width: "50%" }}
            value={this.obs.produto.cest}
            onChange={(e: any) => this.obs.produto.cest = e.target.value}
          />
        </FormGroup>
        <FormGroup label="Validade" labelFor="validade">
          <div style={{ width: 600, display: "flex", alignItems: "center" }}>
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_de}
              onChange={val => {
                this.obs.produto.valido_de = val;

                if (
                  this.obs.produto.valido_ate &&
                  moment(val).isAfter(moment(this.obs.produto.valido_ate))
                ) {
                  this.obs.produto.valido_ate = null; 
                  toast.warning("A data inicial não pode ser maior que a final.");
                }
              }}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
            <Icon icon="arrow-right" style={{ margin: "0 10px" }} />
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_ate}
              onChange={val => {
                this.obs.produto.valido_ate = val;

                if (
                  this.obs.produto.valido_de &&
                  moment(val).isBefore(moment(this.obs.produto.valido_de))
                ) {
                  this.obs.produto.valido_ate = null;
                  toast.warning("A data final não pode ser menor que a inicial.");
                }
              }}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
          </div>
        </FormGroup>

        <MDBRow>
          <MDBCol>
            <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_segments = true}>{"Selecione os Segmentos"}</b></span>
          </MDBCol>
        </MDBRow>

        <Switch
          checked={this.obs.produto.entrada}
          onChange={(e: any) => this.obs.produto.entrada = e.target.checked}
          innerLabelChecked="Entrada" innerLabel="Saída"
          style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
        />

      </div>
    );
  }

  render() {

    return (
      <>
      <Dialog
        isOpen={true}
        title="Editando Produto"
        onClose={this.props.onClose}
        style={{ width: 800, height: 600 }}
      >
        <div className={Classes.DIALOG_BODY}>
          {this.obs.produto && this.renderData() || this.renderNoData()}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button text="Salvar" intent="primary" onClick={this.handleSave} />
          </div>
        </div>
      </Dialog>
      
      <Dialog
        isOpen={this.obs.open_select_segments}
        onClose={() => this.obs.open_select_segments = false}
        style={{ width: 600, height: 400 }}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup
            label="Selecione os segmentos:"
            labelFor="segmentos"
            >
            <div style ={{overflow: "auto", maxHeight: 400}}>
              <Checkbox
                label={"Autopeças"}
                checked={this.obs.produto.seg_auto_pecas}
                onChange={(event: any) => this.obs.produto.seg_auto_pecas = event.target.checked}
              />
              <Checkbox
                label={"Veterinário/pet"}
                checked={this.obs.produto.seg_vet_pet}
                onChange={(event: any) => this.obs.produto.seg_vet_pet = event.target.checked}
              />
              <Checkbox
                label={"Refrigerantes"}
                checked={this.obs.produto.seg_refrigerantes}
                onChange={(event: any) => this.obs.produto.seg_refrigerantes = event.target.checked}
              />
              <Checkbox
                label={"Aguas e outras bebidas"}
                checked={this.obs.produto.seg_agua_out}
                onChange={(event: any) => this.obs.produto.seg_agua_out = event.target.checked}
              />
              <Checkbox
                label={"Lâmpadas, reatores e starter"}
                checked={this.obs.produto.seg_lamp_reatores}
                onChange={(event: any) => this.obs.produto.seg_lamp_reatores = event.target.checked}
              />
              <Checkbox
                label={"Materiais de limpeza"}
                checked={this.obs.produto.seg_mat_limpeza}
                onChange={(event: any) => this.obs.produto.seg_mat_limpeza = event.target.checked}
              />
              <Checkbox
                label={"Pneumáticos, câmaras de ar e protetores de borracha"}
                checked={this.obs.produto.seg_pneumaticos_prot}
                onChange={(event: any) => this.obs.produto.seg_pneumaticos_prot = event.target.checked}
              />
              <Checkbox
                label={"Produtos alimentícios"}
                checked={this.obs.produto.seg_alimenticios}
                onChange={(event: any) => this.obs.produto.seg_alimenticios = event.target.checked}
              />
              <Checkbox
                label={"Produtos de perfumaria e de higiene pessoal e cosméticos"}
                checked={this.obs.produto.seg_perf_cosm}
                onChange={(event: any) => this.obs.produto.seg_perf_cosm = event.target.checked}
              />
              <Checkbox
                label={"Produtos eletrônicos, eletroeletrônicos e eletrodomésticos"}
                checked={this.obs.produto.seg_eletro}
                onChange={(event: any) => this.obs.produto.seg_eletro = event.target.checked}
              />
              <Checkbox
                label={"Rações para animais domésticos"}
                checked={this.obs.produto.seg_racoes}
                onChange={(event: any) => this.obs.produto.seg_racoes = event.target.checked}
              />
              <Checkbox
                label={"Sorvetes e preparados para fabricação de sorvetes em máquinas"}
                checked={this.obs.produto.seg_sorvetes_fab}
                onChange={(event: any) => this.obs.produto.seg_sorvetes_fab = event.target.checked}
              />
              <Checkbox
                label={"Tintas e vernizes"}
                checked={this.obs.produto.seg_tintas}
                onChange={(event: any) => this.obs.produto.seg_tintas = event.target.checked}
              />
              <Checkbox
                label={"Material de construção"}
                checked={this.obs.produto.seg_mat_construcao}
                onChange={(event: any) => this.obs.produto.seg_mat_construcao = event.target.checked}
              />
              <Checkbox
                label={"Veículos automotores novos"}
                checked={this.obs.produto.seg_veiculos_automotores}
                onChange={(event: any) => this.obs.produto.seg_veiculos_automotores = event.target.checked}
              />
              <Checkbox
                label={"Veículos novos de duas e três rodas motorizados"}
                checked={this.obs.produto.seg_veiculos_novos}
                onChange={(event: any) => this.obs.produto.seg_veiculos_novos = event.target.checked}
              />
              <Checkbox
                label={"Medicamentos de uso humano e outros produtos farmacêuticos"}
                checked={this.obs.produto.seg_medicamentos_humano}
                onChange={(event: any) => this.obs.produto.seg_medicamentos_humano = event.target.checked}
              />
            </div>
          </FormGroup>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.obs.open_select_segments = false} />
            <Button
              text="Salvar"
              intent="primary"
              onClick={() => {
                this.obs.open_select_segments = false;
              }}
            />
          </div>
        </div>
        </Dialog>
      </>
    );
  }
}
